/****************************************************
 * Module Name:  qrScanner.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Box } from "@mui/material";
import React from "react";
import QrReader from "react-qr-reader";

const QrScanner = ({ setData, setError }) => {
  const handleScan = async (scanData) => {
    if (scanData && scanData !== "") {
      setData(scanData);
    }
  };
  const handleError = (err) => {
    setError(err);
  };
  return (
    <Box className="App">
      <Box>
        <QrReader
          facingMode={"environment"}
          delay={1000}
          onError={handleError}
          onScan={handleScan}
          style={{ width: "300px" }}
        />
      </Box>
    </Box>
  );
};

export default QrScanner;
